import type { InfraStatus, InfraStatusValue } from "@mc/types"

type BannerCopy = { message: string; code: string; color: string; bg: string }

/** FR section 9 table, verbatim copy (never a bare HTTP status). */
const BANNER_COPY: Partial<Record<InfraStatusValue, BannerCopy>> = {
  crafty_down: {
    message:
      "El panel de control local no responde. Los servidores pueden estar corriendo pero no es posible gestionarlos ahora.",
    code: "ERR_CRAFTY_UNREACHABLE",
    color: "var(--status-warning)",
    bg: "var(--status-warning-subtle)",
  },
  offline: {
    message: "La máquina host está apagada o sin conexión. Los servidores no están disponibles.",
    code: "ERR_HOST_OFFLINE",
    color: "var(--status-error)",
    bg: "var(--status-error-subtle)",
  },
}

export function InfraStatusBanner({ infraStatus }: { infraStatus: InfraStatus | null }) {
  if (!infraStatus) return null
  const copy = BANNER_COPY[infraStatus.status]
  if (!copy) return null // "online" → sin banner, FR section 9

  return (
    <div
      role="alert"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--space-1)",
        padding: "var(--space-4)",
        borderRadius: "var(--radius-md)",
        border: `1px solid ${copy.color}`,
        background: copy.bg,
        animation: "mc-banner-in var(--duration-medium) var(--ease-out)",
      }}
    >
      <p style={{ fontSize: "var(--text-sm)", color: "var(--text-primary)" }}>{copy.message}</p>
      <span style={{ fontSize: "var(--text-xs)", color: "var(--text-muted)" }}>{copy.code}</span>
      <style>{`
        @keyframes mc-banner-in {
          from { opacity: 0; transform: translateY(-4px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  )
}
